<template>
  <layout-block
    :backgroundGradient="{ int: '#473A93', ext: '#0C0058' }"
    padding="32px 16px 30px 16px"
    margin="0 0 48px"
    width="auto"
  >
    <ui-logo />
    <layout-text
      :font-weight="900"
      margin="32px 0 0"
      font-size="16px"
      v-if="!noTitle"
      color="#FFFFFF"
      font-family="Arial, Helvetica, sans-serif"
      font-style="italic"
    >
      {{ title.toUpperCase() }}
    </layout-text>
    <layout-text
      :font-weight="400"
      margin="16px 0 0"
      font-size="16px"
      color="#FFFFFF"
      font-family="Arial, Helvetica, sans-serif"
    >
      {{ subTitle }}
    </layout-text>
    <layout-text
      :font-weight="900"
      margin="16px 0 0"
      font-size="16px"
      color="#FFFFFF"
      font-family="Arial, Helvetica, sans-serif"
    >
      {{ date }}
    </layout-text>
  </layout-block>
</template>

<script>
import LayoutBlock from '@/components/Layout/Block.vue'
import LayoutText from '@/components/Layout/Text.vue'
import UiLogo from '@/components/UI/Logo.vue'

export default {
  name: 'ReportIntro',
  components: {
    LayoutBlock,
    LayoutText,
    UiLogo,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    subTitle: {
      type: String,
      required: true,
    },
    date: {
      type: String,
      required: true,
    },
    noTitle: {
      type: Boolean,
      default: false,
    },
    backgroundColor: {
      type: String,
      default: '#e5e8ee',
    },
  },
}
</script>
